export { log } from './log';
export function parseFileSize(size: number | undefined): string {
  if (!size) return '';
  if (size < 1000) return `${size} B`;
  else if (size < 1000 * 1000) return `${(size / 1000).toFixed(1)} KB`;
  else if (size < 1000 * 1000 * 1000) return `${(size / 1000 / 1000).toFixed(1)} MB`;
  else return '';
}

export const hexToRgba = (hexString: string): number[] => {
  let a = 1;
  if (hexString.length === 9) {
    a = Number((parseInt(hexString.slice(7, 9), 16) / 255).toFixed(2));
  }
  const r = parseInt(hexString.slice(1, 3), 16);
  const g = parseInt(hexString.slice(3, 5), 16);
  const b = parseInt(hexString.slice(5, 7), 16);

  return [r, g, b, a];
};

export function fileToBuffer(file: File): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (fileEvent) => {
      resolve(fileEvent.target?.result as ArrayBuffer);
    };
    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };
    reader.readAsArrayBuffer(file);
  });
}

export * from './providers';
export { default as request } from './request';
export * from './wallet';
export * from './auth';
export * from './dom';
export * from './chain';
export * from './validate';
export * from './common';
export { dateFormat, isBeforeToday } from './date';
export * from './crypto';
export * from './webviewer';
export * from './file';

export { reportGAEvent } from './browser-utils';
